import React, { useState, useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { coverLettersStruct } from '../struct/FormControls'

import { useSelector, useDispatch } from 'react-redux'
import endpoints, { getBackendUrl } from '../../../endpoints';
import axios from 'axios';

export default function WriteCoverForm(props) {        
    const token = useSelector((state) => state.auth.token)
    const [errors, setErrors] = useState()
    const promptRef = useRef()
    
    const sendHandler = async () => {
        setErrors(null)
        if (props.writeCoverStart != undefined) {
            props.writeCoverStart()
        }
        
        let uri = getBackendUrl(endpoints.coverletters_add, token)
        uri = uri.replace('{feedContentId}', props.feedContentId)
        uri = uri.replace('{version}', props.selectedVersion)

        let ok = true
        let message = ''
        try {
            await axios.post(uri, {
                prompt: promptRef.current.value
            })
        } catch (e) {
            ok = false
            if ((e.response) && (e.response.data) && (e.response.data.status === 'invalidate')) {
                message = e.response.data
                setErrors({prompts: message})
            } else { // unknown error
                message = 'Unknown Error - add cover'
            }
        }
        
        if (props.writeCoverFinish != undefined) {
            props.writeCoverFinish(ok, message)
        }
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField 
                    fullWidth
                    name="prompt"
                    label="Prompt"
                    multiline
                    rows={3}
                    variant="standard"
                    inputRef={promptRef}
                    id="writeCoverFormValue"
                    helperText={errors ? errors.prompt : ''}
                />
            </Grid>
            <Grid item xs={12} container direction="row" justifyContent="flex-end" alignItems="center">
                <Button 
                    variant="contained" 
                    onClick={sendHandler} 
                    disabled={(promptRef.current && promptRef.current.value) ? false : true}
                >
                    Make the Cover
                </Button>
            </Grid>
        </Grid>
    );
}